import { PermissionsCategory } from "src/app/auth/permissions";

@PermissionsCategory("CompliancePermissions")
export class CompliancePermissions {
    static readonly None = 0;
    static readonly View = 1;
    static readonly EditInputData = 2;
    static readonly EditSurvey = 3;
}
